import React from "react";

import { formatTimespent } from "src/services/reports.service";
import Text from "src/components/text";

import styles from "./topAccounts.module.scss";

interface TopAccountCardProps {
  item: any;
}

const TopAccountCard: React.FC<TopAccountCardProps> = ({ item }) => {
  const { company, analytics } = item;
  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <div className={styles.imageIcon}>
          {company.icon?.thumbnail ? (
            <img src={company.icon.thumbnail} alt="Company Icon" />
          ) : (
            <span className={styles.initials}>
               {company?.charAt(0).toUpperCase() || "U"}
            </span>
          )}
        </div>
      </div>
      <div className={styles.info}>
        <Text text={company || ""} className={styles.title} lines={1} />
        <div className={styles.metrics}>
          <span>{analytics.users || 0} Users</span>
          <span>{analytics.views || 0} Views</span>
          <span>{formatTimespent(analytics.avgTimeSpent || 0)} Avg Time</span>
        </div>
      </div>
    </div>
  );
};

export default TopAccountCard;
